//#region Dependencies
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CURRENCY, DISPATCH_ID, FORMAT_NUMBER, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient";
import CutTransferModal from "../CutTransferModal";
import { roundToDecimals } from '../../libs/utils/GlobalFunc';
import '../../css/responsive.css';
import $ from "jquery";
import moment from "moment";
let apiClient = ApiClient.getInstance();
const ROUNDING_ADJUSTMENT_LIMIT = 1; // Residuos menores a este monto tras aplicar CU se mandan a la cuenta de ajuste por redondeo
//#endregion

export default function AppsCashCuts(props) {
    //#region REDUX
    const dispatch = useDispatch();
    const notificationReducer = useSelector((store) => store.NotificationReducer);
    const { showAlert } = notificationReducer;
    const enableSpinner = (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value });
    //#endregion

    //#region Variables && Const Declaration
    const { type, cashCut, cancel, updateStatus, bankOptions = [] } = props;
    const [cashTotal, setCashTotal] = useState(0);
    const [voucher, setVoucher] = useState({});
    const [voucherList, setVoucherList] = useState([]);
    const [selectedVoucher, setSelectedVoucher] = useState(-1);
    const [operations, setOperations] = useState([]);
    const [roundingAdjustments, setRoundingAdjustments] = useState([]);
    const [enableContinue, setEnableContinue] = useState(false);
    const [showCutTransferModal, setShowCutTransferModal] = useState(false);
    const [roundVoucher, setRoundVoucher] = useState(0);
    const [currentCheck, setCurrentCheck] = useState(false);
    const [unpaidOps, setUnpaidOps] = useState([]);
    const [showUnpaidOpsModal, setShowUnpaidOpsModal] = useState(false);
    const [toleranceInfo, setToleranceInfo] = useState([]);
    const [selectByAmount, setSelectByAmount] = useState(false);
    const [cashCutAmount, setCashCutAmount] = useState("0");

    const operationFields = [
        { label: "Cliente", key: "cardCode", showInUnpaidOps: true },
        { label: "Tipo", key: "docObjectType", showInUnpaidOps: true },
        { label: "N° Doc", key: "docNum", showInUnpaidOps: true },
        { label: "No.Ref.", key: "NumAtCard", showInUnpaidOps: true },
        { label: "Fact. P.", key: "OriginalNumAtCard", showInUnpaidOps: true },
        { label: "Fecha", key: "docDate", showInUnpaidOps: true },
        { label: "Total", key: "CashTotal", needFormat: true },
        { label: "Aplicado", key: "CashApplied", needFormat: true },
        { label: "Restante", key: "Remaining", needFormat: true }
    ];
    //#endregion

    //#region On Component Init
    useEffect(() => {
        const getOperations = async () => {
            if (cashCut?.idSession) {
                let newCashTotal = 0;
                enableSpinner(true);
                let toleranceRes = await apiClient.getToleranceInfo();
                enableSpinner(false);
                if (!toleranceRes?.status) {
                    showAlert({ type: 'warning', timeOut: 5000, message: toleranceRes?.message || "Ocurrió un error al obtener la información de tolerancias permitidas" });
                } else {
                    setToleranceInfo(toleranceRes?.data ?? [])
                }

                enableSpinner(true);
                const responseApi = await apiClient.showWorkShiftHistory({ idWorkShift: cashCut.idSession });
                enableSpinner(false);

                if (responseApi.status !== SERVICE_RESPONSE.SUCCESS) {
                    return showAlert({ type: "error", message: responseApi?.message || "Error al conectar con el servidor, intente más tarde" });
                }

                if (!responseApi?.data?.sessionMovements?.length) {
                    if (type === 0) { return; }
                    else { showAlert({ type: "warning", message: "No se encontraron operaciónes realizadas por el vendedor" }); }
                } else {
                    const sessionMovements = [...(responseApi.data.sessionMovements || [])];
                    const cesionEnUso = responseApi.data.cesionEnUso || [];
                    //#region Aplicar cesión en uso
                    const cesionNoCancelada = cesionEnUso?.filter(cu => (cu.Canceled || 'N') === 'N');
                   const salesWithCesion = new Set(); // Movimientos originales a los que se les descontó una CU
                    for (const movement of sessionMovements) {
                        const relatedCesion = cesionNoCancelada?.filter(cu => Number(cu.OriginalDocEntry) === Number(movement.docEntry));
                        if (!relatedCesion?.length) continue;
                        salesWithCesion.add(movement.idSale);

                        for (const cu of relatedCesion) {
                            // const cesionAmount = Number(cu.DocTotal || 0);
                            const originalCashPayment = movement.payments.find(p => Number(p.typeMethod) === 0);
                            const cashAmount = Number(originalCashPayment?.amount || 0);
                            const cesionAmount = Math.min(Number(cu.DocTotal || 0), cashAmount);
                            movement.payments = movement.payments.map(payment => {
                                if (Number(payment.typeMethod) !== 0) return payment;

                                return {
                                    ...payment,
                                    amount: roundToDecimals(Number(payment.amount || 0) - cesionAmount, 6,)
                                };
                            });

                            // const originalCashPayment = movement.payments.find(p => Number(p.typeMethod) === 0);
                            const sessionMovement = {
                                ...movement,
                                idSale: `CU${cu.ORCTDocEntry}`,
                                docEntry: cu.ORCTDocEntry,
                                docNum: cu.ORCTDocNum,
                                docTotal: cu.DocTotal,
                                NumAtCard: cu.NumAtCard,
                                OriginalNumAtCard: cu.OriginalNumAtCard,
                                isCesionEnUso: 'Y',
                                docObjectType: cu.ObjType,
                                OriginalDocEntry: cu.OriginalDocEntry,
                                U_BPP_MDTD: cu.U_BPP_MDTD ?? '',
                                U_BPP_PTSC: cu.U_BPP_PTSC ?? '',
                                U_BPP_PTCC: cu.U_BPP_PTCC ?? '',
                                payments: [{
                                    ...originalCashPayment,
                                    // amount: roundToDecimals(Number(cu.DocTotal || 0), 6,),
                                    amount: roundToDecimals(cesionAmount, 6,),
                                    isCesionEnUso: 'Y',
                                    referenceDocEntry: cu.ORCTDocEntry
                                }]
                            }

                            sessionMovements.push(sessionMovement);
                        }
                    }
                    //#endregion

                    let cashOperations = type === 0 ? (sessionMovements).filter(({ payments, FromAppCashCut, VoucherLinked, isForOTRC, CANCELED }) =>  // Only Cash Method && unlinked
                        payments.some(({ typeMethod }) => Number(typeMethod) === 0) && (FromAppCashCut || "N") === 'Y' && (VoucherLinked || "N") === 'N' && (isForOTRC || "N") === 'N' && (CANCELED || "N") === 'N')
                        : (sessionMovements).filter(({ payments, VoucherLinked, isForOTRC, CANCELED }) =>
                            payments.some(({ typeMethod }) => Number(typeMethod) === 0) && (VoucherLinked || "N") === 'N' && (isForOTRC || "N") === 'N' && (CANCELED || "N") === 'N');

                    //#region Ajuste por redondeo (residuo del movimiento original tras aplicar la CU)
                    const getCashAmount = (operation) => roundToDecimals(operation.payments.reduce((acc, curr) => acc += Number(curr.typeMethod) === 0 ? (Number(curr.amount) || 0) : 0, 0), 6);
                    const isRoundingResidual = (operation) => {
                        if (operation.isCesionEnUso === 'Y' || !salesWithCesion.has(operation.idSale)) return false;
                        const residual = getCashAmount(operation);
                        return residual > 0 && residual < ROUNDING_ADJUSTMENT_LIMIT;
                    };
                    const newRoundingAdjustments = cashOperations.filter(isRoundingResidual).map((operation) => ({
                        ...operation,
                        AdjustmentAmount: getCashAmount(operation),
                    }));
                    cashOperations = cashOperations.filter((operation) => !isRoundingResidual(operation));
                    setRoundingAdjustments(newRoundingAdjustments);
                    //#endregion

                    //#region Movimiento original cubierto por completo por su CU
                    // Cuando el pago de la CU (ORCT) incluye la factura original, la CU absorbe todo el efectivo y el original queda en 0.
                    // Se excluye porque el pago de SAP ya lo representa la operación CU (y al depositarla el back marca el original vía BaseIdSales);
                    // si se dejara, al tomar el monto de SAP recuperaría el saldo del mismo pago y se depositaría dos veces.
                    const isFullyCoveredByCesion = (operation) => operation.isCesionEnUso !== 'Y' && salesWithCesion.has(operation.idSale) && getCashAmount(operation) <= 0;

                    cashOperations = cashOperations.filter((operation) => !isFullyCoveredByCesion(operation));
                    //#endregion
                    if (!cashOperations.length) return;

                    cashOperations = cashOperations.map((operation) => ({
                        ...operation,
                        CashTotal: operation.payments.reduce((acc, curr) => acc += Number(curr.typeMethod) === 0 ? (Number(curr.amount) || 0) : 0, 0),
                        Remaining: operation.payments.reduce((acc, curr) => acc += Number(curr.typeMethod) === 0 ? (Number(curr.amount) || 0) : 0, 0),
                        CashApplied: 0,
                        Amount: "0.00",
                        Selected: type === 1 ? true : false, // Si es del app debe de tener seleccionado todo
                    }));

                    //#region Montos reales de SAP
                    // El monto del POS puede diferir por centavos del pago creado en SAP. Lo que se reconcilia en cashCutVoucher es el
                    // saldo abierto de la línea del pago en SAP (OpenAmount), así que el match con los depósitos y el Restante se
                    // calculan con ese monto. Se guarda el del POS en PosCashTotal solo como referencia.
                    // Si la consulta falla se sigue con el monto del POS; el back vuelve a validar contra SAP al aplicar el depósito.
                    enableSpinner(true);
                    const sapAmountsRes = await apiClient.getCashCutSapAmounts({ idSales: cashOperations.map(({ idSale }) => idSale) }).catch(error => ({ status: 0, message: error?.message }));
                    enableSpinner(false);
                    if (sapAmountsRes?.status !== SERVICE_RESPONSE.SUCCESS) {
                        showAlert({ type: 'warning', timeOut: 8000, message: `${sapAmountsRes?.message || 'No se pudieron consultar los montos de SAP'}. Se usarán los montos registrados en el punto de venta.` });
                    } else {
                        const sapAmounts = sapAmountsRes?.data ?? [];
                        // Una operación del corte no debería estar reconciliada en SAP (ni total ni parcialmente): si lo está es por
                        // un fallo previo (reconciliación manual, un depósito que se aplicó y no marcó VoucherLinked, etc.).
                        // Se marca con SapStatus/SapWarning para mostrarlo en la tarjeta de la operación y se excluye de la
                        // selección automática cuando no hay nada que depositar.
                        cashOperations = cashOperations.map((operation) => {
                            const sapAmount = sapAmounts.find(({ idSale }) => `${idSale}` === `${operation.idSale}`);
                            if (!sapAmount) {
                                return { // Sin pago en SAP: el back rechazaría el depósito que la incluya
                                    ...operation,
                                    PosCashTotal: operation.CashTotal,
                                    SapAmountFound: false,
                                    SapStatus: 'NOT_FOUND',
                                    SapWarning: 'No se encontró el pago en SAP. No se incluye en la selección automática.',
                                };
                            }
                            const openAmount = roundToDecimals(Number(sapAmount.OpenAmount || 0), 2);
                            const lineAmount = roundToDecimals(Number(sapAmount.LineAmount || 0), 2);
                            const SapStatus = openAmount <= 0 ? 'RECONCILED' : openAmount < lineAmount ? 'PARTIAL' : 'OK';
                            const SapWarning = SapStatus === 'RECONCILED' ? `El pago ya está reconciliado en SAP (${FORMAT_NUMBER.new(lineAmount)}). No hay saldo por depositar.`
                                : SapStatus === 'PARTIAL' ? `El pago en SAP está reconciliado parcialmente: pendiente ${FORMAT_NUMBER.new(openAmount)} de ${FORMAT_NUMBER.new(lineAmount)}.`
                                    : null;
                            return {
                                ...operation,
                                PosCashTotal: operation.CashTotal,
                                SapLineAmount: lineAmount,
                                SapSharedLine: !!sapAmount.sharedLine, // El pago cubre varias operaciones; su saldo no es exclusivo de esta
                                SapAmountFound: true,
                                SapStatus,
                                SapWarning,
                                CashTotal: Math.max(openAmount, 0),
                                Remaining: Math.max(openAmount, 0),
                            };
                        });

                        const sapAnomalies = cashOperations.filter(({ SapStatus }) => SapStatus && SapStatus !== 'OK');
                        if (sapAnomalies.length) {
                            console.warn(`[AppsCashCuts] Operaciones con observaciones en SAP | idSession: ${cashCut.idSession}`, sapAnomalies.map(({ idSale, docNum, SapStatus, PosCashTotal, SapLineAmount, CashTotal }) => ({ idSale, docNum, SapStatus, PosCashTotal, SapLineAmount, OpenAmount: CashTotal })));
                            showAlert({ type: 'warning', timeOut: 12000, message: `Hay ${sapAnomalies.length} operación(es) con observaciones en SAP (N° Doc: ${sapAnomalies.map(({ docNum }) => docNum).join(', ')}). Revise el detalle en cada operación.` });
                        }
                    }
                    //#endregion Montos reales de SAP

                    newCashTotal = cashOperations.reduce((acc, curr) => acc += (Number(curr.CashTotal) || 0), 0);
                    setSelectByAmount(!!cashOperations[0]?.SelectByAmount);
                    setSelectedVoucher(0);
                    setOperations(cashOperations);
                    setCashTotal(newCashTotal);
                }
                if (newCashTotal > 0) { $("#AppsCashAmountModal").modal("show"); }
                else { $("#AppsCashCutModal").modal("show"); }
            }
        }

        setDefaultValues();
        getOperations();
    }, []);

    useEffect(() => {
        if (showCutTransferModal) {
            $('#cutTransferModal').modal('show');
        }
    }, [showCutTransferModal]);

    useEffect(() => {
        if (showUnpaidOpsModal) {
            $('#unpaidOpsModal').modal('show');
        }
    }, [showUnpaidOpsModal]);
    //#endregion

    //#region ModalsActions
    const closeModals = async () => {
        $("#AppsCashAmountModal").modal("hide");
        $("#AppsCashCutModal").modal("hide");
        $("#LinkOperationsModal").modal("hide");
        $("#continueWithoutVouchers").modal("hide")
        $("#continueModal").modal("hide");
        $("#cancelModal").modal("hide");
        $("#cutTransferModal").modal("hide");
        $("#cutTransferUsersModal").modal("hide");
        $("#confirmCutTransferModal").modal("hide");
        $("#showUnpaidOpsModal").modal("hide");

        setTimeout(cancel, 500);
    };

    const setDefaultValues = () => {
        setVoucher({
            number: "",
            bank: "",
            date: moment().format("YYYY-MM-DD"),
            currency: "PEN",
            total: "0.00",
            destinationAccount: '',
        });
    }

    const validateRound = (background = false) => {
        const currency = CURRENCY; // Actualmente los registros de vouchers son en esta moneda
        const currentTolerance = toleranceInfo?.find(t => t.CurrCode === currency || t.DocCurrCod === currency || t.ISOCurrCod === currency) ?? {};
        const vouchersTotal = voucherList.reduce((acc, current) => acc += Number(current.Total), 0);
        //#region VALIDACIÓN REDONDEO
        const round2 = (value) =>
            Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
        const restante = round2(
            cashTotal - vouchersTotal
        );

        if (currentCheck) {
            const TOLERANCE = restante > 0
                ? Number(currentTolerance?.MaxOutDiff ?? 0) // Falta
                : Number(currentTolerance?.MaxInDiff ?? 0); // Sobra

            if (Math.abs(restante) > TOLERANCE) {
                if (!background) {
                    showAlert({
                        type: "warning",
                        message: `El depósito supera la tolerancia permitida. Restante: ${(Math.abs(restante))}`
                    });
                }
                return false
            }

            if (!background) {
                setRoundVoucher(restante)
            }
        } else {
            // Sobra dentro de tolerancia sin redondeo marcado: validateVoucher ya no lo bloquea al agregar el depósito
            // (el efectivo pendiente viene de SAP y puede diferir por centavos), así que aquí se pide marcar el redondeo.
            // Un excedente mayor a la tolerancia no llega hasta aquí porque validateVoucher no deja agregar ese depósito.
            if (restante < 0 && Math.abs(restante) <= Number(currentTolerance?.MaxInDiff ?? 0)) {
                if (!background) {
                    showAlert({ type: "warning", message: `El monto depositado supera el efectivo por ${CURRENCY} ${FORMAT_NUMBER.new(Math.abs(restante))}. Selecciona la opción de redondeo, ya que se encuentra dentro de la tolerancia permitida.`, timeOut: 8000 });
                }
                return false;
            }
            if (type === 1) { // Se hizo para las apps principalmente, revisar si aplica igual para counter
                const TOLERANCE = Number(currentTolerance?.MaxOutDiff ?? 0); // Falta
                if (restante > 0 && restante <= TOLERANCE) { // Restante se considera positivo por que falta, si fuera negativo entonces sobra
                    showAlert({ type: "warning", message: `Selecciona la opción de redondeo, ya que el monto se encuentra dentro de la tolerancia permitida.`, timeOut: 8000 });
                    return false;
                }
            }

            if (!background) {
                setRoundVoucher(0)
            }
        }
        //#endregion
        return true
    }

    const validateVoucher = async () => {

        const vouchersTotal = voucherList.reduce((acc, current) => acc += Number(current.Total), 0);
        if (!voucher.number) { return showAlert({ type: "warning", message: "Ingrese un Numero de movimiento valido" }); }

        if (!voucher.bank) { return showAlert({ type: "warning", message: "Ingrese un Banco valido" }); }
        if (!moment(voucher.date || "").isValid()) { return showAlert({ type: "warning", message: "Ingrese una fecha valida" }); }
        if (!voucher.currency) { return showAlert({ type: "warning", message: "Ingrese una moneda valida" }); }

        if (!Number(`${voucher.total || 0}`.replace(/,/g, ""))) { return showAlert({ type: "warning", message: "Ingrese un Total valido" }); }

        if (voucherList.some( // El quiebre es por todos los siguientes datos, ya que un número de referencia con el mismo monto, moneda y banco puede estar en 2 depositos pero con fechas diferentes
            ({ Number: voucherNumber, Bank, Date: voucherDate, Currency, Total }) =>
                `${voucherNumber || ""}` === `${voucher.number || ""}` &&
                Bank === voucher.bank &&
                moment(voucherDate).format("YYYY-MM-DD") === moment(voucher.date).format("YYYY-MM-DD") &&
                Currency === voucher.currency &&
                Number(`${Total ?? 0}`.replace(/,/g, "")) === Number(`${voucher.total ?? 0}`.replace(/,/g, ""))
        )) {
            return showAlert({ type: "warning", message: "Ya se encuentra registrado este depósito en la operación" });
        }

        //#region Excedente contra el efectivo pendiente
        // cashTotal es la suma del saldo abierto en SAP (ver "Montos reales de SAP" en getOperations), que puede ser unos
        // centavos menor que lo registrado en el POS y que lo que realmente se depositó. Antes cualquier excedente se bloqueaba
        // si no estaba marcado el redondeo; ahora un excedente dentro de MaxInDiff se deja agregar sin importar el check:
        //   - validateRound lo vuelve a revisar al continuar y pide marcar el redondeo (el ajuste se decide con el corte completo).
        //   - El back calcula el redondeo real por depósito contra SAP y lo manda a RoundPlus (CashCutVoucher, regla 5).
        // Solo se bloquea un excedente mayor a la tolerancia: monto mal capturado o depósito de operaciones sin saldo en SAP.
        const currentTolerance = toleranceInfo?.find(t => t.CurrCode === CURRENCY || t.DocCurrCod === CURRENCY || t.ISOCurrCod === CURRENCY) ?? {};
        const round2 = (value) => Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
        const surplus = round2(Number(vouchersTotal || 0) + Number(`${voucher.total || 0}`.replace(/,/g, "")) - cashTotal);
        if (surplus > Number(currentTolerance?.MaxInDiff ?? 0)) {
            return showAlert({ type: "warning", message: `El monto depositado supera el total de efectivo pendiente (${CURRENCY} ${FORMAT_NUMBER.new(cashTotal)}) por ${CURRENCY} ${FORMAT_NUMBER.new(surplus)}` });
        }
        //#endregion

        enableSpinner(true)
        const apiResponse = await apiClient.validateVoucher({ voucher });
        enableSpinner(false)

        if (apiResponse.status !== SERVICE_RESPONSE.SUCCESS) {
            return showAlert({ type: "error", message: apiResponse.message || "Error al conectar con el servidor, intente más tarde" });
        }

        voucherList.push({ ...apiResponse.data, operations: [] });
        setDefaultValues();
    };

    const verifyCashCutAmount = () => {
        let newCashTotal = selectByAmount ? Number(`${cashCutAmount || ""}`.replace(/,/g, "")) : operations.reduce((acc, current) => acc += (current.Selected ? Number(current.CashTotal) : 0), 0);
        if (newCashTotal <= 0) { return showAlert({ type: "warning", message: "Ingrese un monto valido a depositar para continuar" }); }
        else if (newCashTotal > cashTotal) { return showAlert({ type: "warning", message: "El monto ingresado es superior al total de las operaciones" }); }

        setOperations(operations.filter((operation) => operation.Selected || selectByAmount));
        setCashTotal(newCashTotal);
        $("#AppsCashAmountModal").modal("hide");
        $("#AppsCashCutModal").modal("show");
    };

    const verifyVoucherList = async () => {
        if (!validateRound()) return//VALIDACION DE REDONDEO SI APLICA
        if (!voucherList.length) { return $("#continueWithoutVouchers").modal("show"); }

        //#region Validar existencia de pagos para las operaciones
        if (type === 0) {
            enableSpinner(true);
            const checkPayments = await apiClient.checkCashCutPayments({ operations });
            enableSpinner(false);
            if (!checkPayments?.status) {
                if (checkPayments?.data?.length) {
                    setUnpaidOps(checkPayments?.data);
                    openUnpaidOpsModal();
                    return;
                } else {
                    return showAlert({ type: "error", message: checkPayments?.message || "Error al conectar con el servidor, intente más tarde" });
                }
            }
        }
        //#endregion Validar existencia de pagos para las operaciones

        await $("#AppsCashCutModal").modal("hide");
        await $("#LinkOperationsModal").modal("show");
    };

    const changeAmountOperation = (value, index) => {
        let auxOperations = JSON.parse(JSON.stringify(operations));
        auxOperations[index].Amount = value;
        setOperations(auxOperations);
    };

    const addOperation = (index) => {
        let auxOperations = JSON.parse(JSON.stringify(operations));
        let auxVoucherList = JSON.parse(JSON.stringify(voucherList));
        let operation = auxOperations[index];
        let voucher = auxVoucherList[selectedVoucher];

        const amount = Number(`${operation.Amount || 0}`.replace(/,/g, ""));
        if (!amount) { return showAlert({ type: "warning", message: "Ingrese un Total valido" }); }
        if (amount > operation.Remaining) { return showAlert({ type: "warning", message: "El monto supera la cantidad de la operación" }); }

        const subIndex = voucher.operations.findIndex(({ idSale }) => idSale === operation.idSale)
        if (subIndex !== -1) { voucher.operations[subIndex].CashApplied += amount; }
        else {
            operation.CashApplied = amount;
            voucher.operations.push(operation);
        }

        let remaining = Number((voucher.Total - voucher.operations.reduce((acc, current) => acc += Number(current.CashApplied), 0)).toFixed(2));
        if (remaining < 0) { return showAlert({ type: "warning", message: "El monto supera la cantidad del depósito" }); }

        operation.Amount = "";
        operation.Remaining -= amount;
        voucher.Remaining = remaining;

        setOperations(auxOperations);
        setVoucherList(auxVoucherList);
        setEnableContinue(!auxVoucherList.some(({ Remaining }) => (Remaining + (roundVoucher > 0 ? 0 : roundVoucher)) > 0));
    };

    const removeOperation = (cOperation, index) => {
        let auxOperations = JSON.parse(JSON.stringify(operations));
        let auxVoucherList = JSON.parse(JSON.stringify(voucherList));
        let operation = auxOperations.find(({ idSale }) => idSale === cOperation.idSale);
        let voucher = auxVoucherList[selectedVoucher];
        voucher.operations.splice(index, 1);
        // AbsorbedAmount: centavos que fillOperationsByMatch dio por cubiertos dentro de tolerancia; al quitar la operación se regresan
        voucher.Remaining = roundToDecimals(Number(voucher.Remaining) + Number(cOperation.CashApplied) + Number(voucher.AbsorbedAmount || 0), 2);
        voucher.AbsorbedAmount = 0;
        operation.Remaining = roundToDecimals(Number(operation.Remaining) + Number(cOperation.CashApplied) + Number(cOperation.AbsorbedAmount || 0), 2);

        setOperations(auxOperations);
        setVoucherList(auxVoucherList);
        setEnableContinue(false);
    };

    const removeDeposit = (cVoucher, index) => {
        const auxVoucherList = [...voucherList];
        auxVoucherList.splice(index, 1);

        setVoucherList(auxVoucherList);
    };

    const fillOperations = async () => {
        enableSpinner(true);
        const vouchersTotal = voucherList.reduce((acc, current) => acc += Number(current.Total), 0);
        let availableOperations = JSON.parse(JSON.stringify(operations));
        let cashApplied;

        const addOperation = (cOperation) => {
            if (cashApplied < vouchersTotal) {
                cashApplied += Number(cOperation.CashTotal);
                return true;
            }
            return false;
        };

        const hasIncompleteDoc = (array) => {
            return (array.reduce((acc, { CashTotal }) => acc += Number(CashTotal), 0) - vouchersTotal) > 0;
        };

        cashApplied = 0;
        let availableOperationsASC = availableOperations.sort((a, b) => (Number(a.CashTotal) || 0) - (Number(b.CashTotal) || 0)).filter(addOperation);

        cashApplied = 0;
        let availableOperationsDESC = availableOperations.sort((a, b) => (Number(b.CashTotal) || 0) - (Number(a.CashTotal) || 0)).filter(addOperation);

        availableOperations = availableOperationsASC; // Fill docs by ASC by default

        // Fill docs by DESC conditions
        if (hasIncompleteDoc(availableOperationsASC)) {
            if (availableOperationsASC.length <= availableOperationsDESC.length || !hasIncompleteDoc(availableOperationsDESC)) {
                availableOperations = availableOperationsDESC;
            }
        } else {
            if (availableOperationsASC.length <= availableOperationsDESC.length && !hasIncompleteDoc(availableOperationsDESC)) {
                availableOperations = availableOperationsDESC;
            }
        }

        // Link docs with vouchers
        let auxVoucherList = JSON.parse(JSON.stringify(voucherList));
        let auxOperations = JSON.parse(JSON.stringify(operations));

        for (const operation of availableOperations) {
            let cOperation = auxOperations.find(({ idSale }) => idSale === operation.idSale);
            let amount = Number(operation.Remaining);

            while (amount > 0) {
                let voucher = auxVoucherList.find(({ Remaining }) => Remaining > 0);

                if (voucher) {
                    if (Number(voucher.Remaining) > amount) {
                        cOperation.CashApplied = amount;
                        cOperation.Remaining = Number((cOperation.Remaining - cOperation.CashApplied).toFixed(2));
                        voucher.Remaining = Number((voucher.Remaining - amount).toFixed(2));
                        amount = 0;
                    } else {
                        amount = Number((amount - voucher.Remaining).toFixed(2));
                        cOperation.CashApplied = Number(voucher.Remaining);
                        cOperation.Remaining = Number((cOperation.Remaining - cOperation.CashApplied).toFixed(2));
                        voucher.Remaining = 0;
                    }
                    voucher.operations.push(JSON.parse(JSON.stringify(cOperation)));
                } else { break; }
            }
        }

        setOperations(auxOperations);
        setVoucherList(auxVoucherList);
        setEnableContinue(!auxVoucherList.some(({ Remaining }) => (Remaining + (roundVoucher > 0 ? 0 : roundVoucher)) > 0));
        enableSpinner(false);
    }

    // Selección automática por match de montos (los montos de las operaciones ya vienen de SAP, ver getCashCutSapAmounts).
    // Se resuelve en fases, de la más confiable a la menos:
    //   Fase 1 - 1 a 1: un depósito = una operación con el total más parecido dentro de tolerancia.
    //   Fase 2 - N a 1: un depósito = varias operaciones completas cuya suma cuadra dentro de tolerancia (búsqueda acotada).
    //   Fase 3 - Lógica anterior (fillOperations): lo que quede se reparte secuencialmente seleccionando por ASC/DESC contra el
    //            total pendiente de los depósitos; aquí sí se pueden partir operaciones entre depósitos.
    //   Fase 4 - Cierre de centavos: diferencias dentro de tolerancia se dan por cubiertas (AbsorbedAmount) para que no queden
    //            operaciones "incompletas" por 0.01 que se transfieran al siguiente corte. Es lo mismo que hace el back
    //            (CashCutVoucher, Version 3): reconcilia el saldo completo y manda la diferencia a la línea de redondeo.
    // Las fases 1 y 2 nunca parten operaciones; así cada depósito queda ligado a documentos completos siempre que se pueda.
    const fillOperationsByMatch = async () => {
        enableSpinner(true);
        const currency = CURRENCY; // Actualmente los registros de vouchers son en esta moneda
        const currentTolerance = toleranceInfo?.find(t => t.CurrCode === currency || t.DocCurrCod === currency || t.ISOCurrCod === currency) ?? {};
        const maxOutDiff = roundToDecimals(Number(currentTolerance?.MaxOutDiff ?? 0), 2); // Falta: las operaciones suman más que el depósito
        const maxInDiff = roundToDecimals(Number(currentTolerance?.MaxInDiff ?? 0), 2); // Sobra: el depósito es mayor que las operaciones
        const MAX_SEARCH_NODES = 200000; // Tope de la búsqueda de combinaciones para no congelar el navegador con muchos documentos

        let auxVoucherList = JSON.parse(JSON.stringify(voucherList));
        let auxOperations = JSON.parse(JSON.stringify(operations));
        const summary = { oneToOne: 0, combined: 0, sequential: 0 };

        //#region Helpers
        const toCents = (value) => Math.round(Number(value || 0) * 100);
        const isWithinTolerance = (diff) => diff >= 0 ? diff <= maxInDiff : Math.abs(diff) <= maxOutDiff; // diff = depósito - operaciones
        // Sin pago en SAP o ya reconciladas no entran: el back rechazaría el depósito completo que las incluya
        const isSelectable = (operation) => Number(operation.Remaining) > 0 && !['NOT_FOUND', 'RECONCILED'].includes(operation.SapStatus);
        const pendingVouchers = () => auxVoucherList.filter(({ Remaining }) => Number(Remaining) > 0);
        const pendingOperations = () => auxOperations.filter(isSelectable);

        const linkOperation = (voucher, cOperation, amount) => {
            cOperation.CashApplied = amount;
            cOperation.Remaining = roundToDecimals(Number(cOperation.Remaining) - amount, 2);
            voucher.Remaining = roundToDecimals(Number(voucher.Remaining) - amount, 2);
            voucher.operations.push(JSON.parse(JSON.stringify(cOperation)));
        };

        // Liga operaciones completas a un depósito; si suman más que el depósito (dentro de tolerancia) la última queda con un
        // residuo que la fase 4 da por cubierto
        const linkWholeOperations = (voucher, operationsToLink) => {
            for (const cOperation of operationsToLink) {
                const amount = roundToDecimals(Math.min(Number(cOperation.Remaining), Number(voucher.Remaining)), 2);
                if (amount <= 0) continue;
                linkOperation(voucher, cOperation, amount);
            }
        };

        // Busca la combinación de operaciones completas que más se acerca al monto objetivo dentro de tolerancia.
        // Trabaja en centavos para evitar errores de punto flotante. Ordena de mayor a menor y poda cuando ni sumando todo lo
        // que queda se alcanza el mínimo. Prefiere la diferencia más chica y, a igual diferencia, menos operaciones.
        const findBestCombination = (targetAmount, candidates) => {
            const target = toCents(targetAmount);
            const minSum = target - toCents(maxInDiff);
            const maxSum = target + toCents(maxOutDiff);
            const items = candidates
                .map((operation) => ({ operation, cents: toCents(operation.Remaining) }))
                .sort((a, b) => b.cents - a.cents);
            const suffix = new Array(items.length + 1).fill(0);
            for (let i = items.length - 1; i >= 0; i--) suffix[i] = suffix[i + 1] + items[i].cents;

            let best = null;
            let nodes = 0;
            const chosen = [];
            const search = (start, sum) => {
                nodes++;
                if (chosen.length > 1 && sum >= minSum && sum <= maxSum) { // > 1: las de una sola operación ya las resolvió la fase 1
                    const diff = Math.abs(target - sum);
                    if (!best || diff < best.diff || (diff === best.diff && chosen.length < best.items.length)) {
                        best = { diff, items: [...chosen] };
                    }
                }
                for (let i = start; i < items.length; i++) {
                    if (best?.diff === 0 || nodes > MAX_SEARCH_NODES) return;
                    if (sum + suffix[i] < minSum) return;
                    const next = sum + items[i].cents;
                    if (next > maxSum) continue;
                    chosen.push(items[i]);
                    search(i + 1, next);
                    chosen.pop();
                }
            };
            search(0, 0);
            if (nodes > MAX_SEARCH_NODES) console.warn(`[fillOperationsByMatch] Búsqueda de combinaciones truncada | Depósito: ${targetAmount} | Operaciones: ${items.length}`);
            return best?.items.map(({ operation }) => operation) ?? null;
        };
        //#endregion

        //#region Fase 1: match 1 a 1 (las parejas más parecidas primero)
        const pairs = [];
        pendingVouchers().forEach((voucher) => {
            pendingOperations().forEach((cOperation) => {
                const diff = roundToDecimals(Number(voucher.Remaining) - Number(cOperation.Remaining), 2);
                if (isWithinTolerance(diff)) pairs.push({ voucher, cOperation, diff: Math.abs(diff) });
            });
        });
        pairs.sort((a, b) => a.diff - b.diff);
        const matchedVouchers = new Set();
        const matchedOperations = new Set();
        for (const { voucher, cOperation } of pairs) {
            if (matchedVouchers.has(voucher) || matchedOperations.has(cOperation)) continue;
            linkWholeOperations(voucher, [cOperation]);
            matchedVouchers.add(voucher);
            matchedOperations.add(cOperation);
            summary.oneToOne++;
        }
        //#endregion

        //#region Fase 2: un depósito con varias operaciones completas (depósitos más grandes primero)
        for (const voucher of [...pendingVouchers()].sort((a, b) => Number(b.Remaining) - Number(a.Remaining))) {
            const combination = findBestCombination(voucher.Remaining, pendingOperations());
            if (!combination) continue;
            linkWholeOperations(voucher, combination);
            summary.combined++;
        }
        //#endregion

        //#region Fase 3: lógica anterior (fillOperations) con lo que quedó pendiente
        const remainingVouchersTotal = roundToDecimals(pendingVouchers().reduce((acc, { Remaining }) => acc + Number(Remaining), 0), 2);
        if (remainingVouchersTotal > 0 && pendingOperations().length) {
            let cashApplied = 0;
            const addOperation = (cOperation) => {
                if (cashApplied < remainingVouchersTotal) {
                    cashApplied += Number(cOperation.Remaining);
                    return true;
                }
                return false;
            };
            const hasIncompleteDoc = (array) => (array.reduce((acc, { Remaining }) => acc + Number(Remaining), 0) - remainingVouchersTotal) > 0;

            cashApplied = 0;
            const selectionASC = [...pendingOperations()].sort((a, b) => Number(a.Remaining) - Number(b.Remaining)).filter(addOperation);
            cashApplied = 0;
            const selectionDESC = [...pendingOperations()].sort((a, b) => Number(b.Remaining) - Number(a.Remaining)).filter(addOperation);

            let selection = selectionASC; // Mismas reglas de decisión que fillOperations
            if (hasIncompleteDoc(selectionASC)) {
                if (selectionASC.length <= selectionDESC.length || !hasIncompleteDoc(selectionDESC)) selection = selectionDESC;
            } else if (selectionASC.length <= selectionDESC.length && !hasIncompleteDoc(selectionDESC)) {
                selection = selectionDESC;
            }

            for (const cOperation of selection) {
                while (Number(cOperation.Remaining) > 0) {
                    const voucher = auxVoucherList.find(({ Remaining }) => Number(Remaining) > 0);
                    if (!voucher) break;
                    linkOperation(voucher, cOperation, roundToDecimals(Math.min(Number(cOperation.Remaining), Number(voucher.Remaining)), 2));
                    summary.sequential++;
                }
            }
        }
        //#endregion

        //#region Fase 4: cierre de centavos dentro de tolerancia
        const voucherDiff = (voucher) => roundToDecimals(Number(voucher.Total) - voucher.operations.reduce((acc, { CashApplied, AbsorbedAmount }) => acc + Number(CashApplied || 0) + Number(AbsorbedAmount || 0), 0), 2);
        for (const voucher of auxVoucherList) {
            // Operación con residuo (falta en el depósito): se da por cubierta si el depósito sigue dentro de tolerancia
            for (const linked of voucher.operations) {
                const cOperation = auxOperations.find(({ idSale }) => idSale === linked.idSale);
                const residual = roundToDecimals(Number(cOperation?.Remaining || 0), 2);
                if (residual <= 0 || residual > maxOutDiff) continue;
                if (!isWithinTolerance(roundToDecimals(voucherDiff(voucher) - residual, 2))) continue;
                linked.AbsorbedAmount = roundToDecimals(Number(linked.AbsorbedAmount || 0) + residual, 2);
                cOperation.Remaining = 0;
            }
            // Depósito con sobrante dentro de tolerancia: se da por cubierto (el back lo manda a la línea de redondeo)
            if (voucher.operations.length && Number(voucher.Remaining) > 0 && Number(voucher.Remaining) <= maxInDiff) {
                voucher.AbsorbedAmount = roundToDecimals(Number(voucher.AbsorbedAmount || 0) + Number(voucher.Remaining), 2);
                voucher.Remaining = 0;
            }
        }
        //#endregion

        // Lo que no se pudo ligar se queda en Operaciones Disponibles (en apps se transfiere como incompleta al finalizar)
        const unmatchedOperations = pendingOperations();
        const excludedOperations = auxOperations.filter(({ SapStatus }) => ['NOT_FOUND', 'RECONCILED'].includes(SapStatus));
        // console.log(`fillOperationsByMatch>> summary`, summary, { unmatchedOperations, excludedOperations });
        if (unmatchedOperations.length || excludedOperations.length) {
            showAlert({
                type: 'info',
                timeOut: 10000,
                message: [
                    unmatchedOperations.length ? `${unmatchedOperations.length} operación(es) quedaron sin depósito (N° Doc: ${unmatchedOperations.map(({ docNum }) => docNum).join(', ')})` : '',
                    excludedOperations.length ? `${excludedOperations.length} operación(es) excluidas por observaciones en SAP (N° Doc: ${excludedOperations.map(({ docNum }) => docNum).join(', ')})` : '',
                ].filter(Boolean).join('. '),
            });
        }

        setOperations(auxOperations);
        setVoucherList(auxVoucherList);
        setEnableContinue(!auxVoucherList.some(({ Remaining }) => (Remaining + (roundVoucher > 0 ? 0 : roundVoucher)) > 0));
        enableSpinner(false);
    }

    const reconciliation = async () => {
        /* Original */
        /*const incompleteOperations = operations.filter(({ Remaining }) => !!Remaining).map((oData) => ({
            IdSale: oData.idSale,
            Remaining: oData.Remaining,
            payments: 
        }));*/
        /* Version 2: Por CU */
        const incompleteOperations = operations?.filter(({ Remaining }) => !!Remaining)?.map((oData) => {
            let IdSales = [];
            if (oData.isCesionEnUso === 'Y') {
                let remaining = roundToDecimals(Number(oData.Remaining || 0), 6);
                IdSales = oData?.payments?.filter(payment => Number(payment.typeMethod) === 0)?.map(payment => {
                    const paymentAmount = roundToDecimals(Number(payment.amount || 0), 6);
                    if (remaining <= 0) return null;
                    const available = roundToDecimals(Math.min(paymentAmount, remaining), 6);
                    remaining = roundToDecimals(remaining - available, 6);

                    return {
                        IdSale: payment.idSale,
                        Remaining: available
                    };

                })
                    ?.filter(Boolean);
            }

            return {
                IdSale: oData.idSale,
                Remaining: roundToDecimals(Number(oData.Remaining || 0), 6),
                IdSales,
                isCesionEnUso: oData?.isCesionEnUso || 'N'
            };

        });

        for (const voucher of voucherList || []) {
            for (const operation of voucher?.operations || []) {
                operation.RoundApplied = 'N';
                operation.RoundAmount = 0;
            }
        }

        if (currentCheck && Math.abs(roundVoucher) > 0 && voucherList?.length) { // Aplicar el redondeo al último voucher para que afecte el Remaining
            let pendingRound = roundToDecimals(Math.abs(roundVoucher), 6);
            const lastVoucher = voucherList[voucherList?.length - 1];

            for (let index = lastVoucher?.operations?.length - 1; index >= 0 && pendingRound > 0; index--) { // Se recorren las operaciones del último voucher de atrás hacia adelante
                const operation = lastVoucher?.operations?.[index];
                const incompleteOperation = incompleteOperations?.find(({ IdSale }) => IdSale === operation.idSale);

                if (!incompleteOperation || Number(incompleteOperation.Remaining) <= 0)
                    continue;

                const appliedRound = roundToDecimals(Math.min(Number(incompleteOperation.Remaining), pendingRound), 6);
                incompleteOperation.Remaining = roundToDecimals(Number(incompleteOperation.Remaining) - appliedRound, 6);
                pendingRound = roundToDecimals(pendingRound - appliedRound, 6);

                operation.RoundApplied = appliedRound > 0 ? 'Y' : 'N';
                operation.RoundAmount = appliedRound;
            }

            for (let index = incompleteOperations.length - 1; index >= 0; index--) {
                if (Number(incompleteOperations[index].Remaining) <= 0) {
                    incompleteOperations.splice(index, 1);
                }
            }
        }

        if (incompleteOperations.length && type === 0) {
            const remainingAmount = incompleteOperations.reduce(
                (acc, voucher) => acc + Number(voucher.Remaining ?? 0),
                0
            );
            const exactRound = currentCheck && roundVoucher === remainingAmount;
            if (!exactRound) {
                return showAlert({ type: "warning", message: "Los cortes de planta deben ser Exactos" });
            }

        }
        let auxVoucherList = JSON.parse(JSON.stringify(voucherList));

        const assignedAdjustments = new Set(); // Cada ajuste por redondeo se manda solo con el primer voucher que lleva su CU
        const OperationsList = voucherList.map((vData, index) => {
            const isLast = index === voucherList.length - 1;
            if (currentCheck && isLast) {
                vData.roundVoucher = roundVoucher
                vData.currentCheck = currentCheck
            }
            const cuBaseIdSales = vData.operations
                .filter((oData) => oData?.isCesionEnUso === 'Y')
                .flatMap((oData) => oData?.payments?.filter(p => p.idSale && Number(p.typeMethod) === 0)?.map(p => `${p.idSale}`) || []);
            const RoundingAdjustments = roundingAdjustments
                .filter((adjustment) => cuBaseIdSales.includes(`${adjustment.idSale}`) && !assignedAdjustments.has(`${adjustment.idSale}`))
                .map((adjustment) => {
                    assignedAdjustments.add(`${adjustment.idSale}`);
                    return {
                        IdSale: adjustment.idSale,
                        DocEntry: adjustment.docEntry, // DocEntry de la factura original
                        DocNum: adjustment.docNum,
                        AdjustmentAmount: Number(adjustment.AdjustmentAmount || 0),
                        PaymentDocEntry: vData?.roundingPayments?.find(({ IdSale }) => `${IdSale}` === `${adjustment.idSale}`)?.PaymentDocEntry ?? null, // Si ya se creó en un intento anterior no se vuelve a crear
                    };
                });
            return ({
                Code: vData.Code,
                Number: vData.Number,
                Currency: vData.Currency,
                ChangeRate: vData.ChangeRate,
                Total: Number(vData.Total),
                Operations: vData.operations.map((oData) => ({
                    IdSale: oData.idSale,
                    SumApplied: oData.CashApplied,
                    DocumentAmount: Number(oData.docTotal || 0),
                    ObjType: oData.docObjectType || '',
                    RoundApplied: oData.RoundApplied || 'N',
                    RoundAmount: Number(oData.RoundAmount || 0),
                    isCesionEnUso: oData?.isCesionEnUso || 'N',
                    BaseIdSales: oData?.isCesionEnUso === 'Y' ? oData?.payments?.filter(p => p.idSale && Number(p.typeMethod) === 0)?.map(p => p.idSale)?.join(',') || '' : '',
                })),
                RefDate: moment(vData.Date).isValid() ? moment(vData.Date).format('YYYY-MM-DD') : null,
                destinationAccount: vData?.destinationAccount || '',

                slResponseJDT: vData.slResponseJDT,
                roundVoucher: vData?.roundVoucher ?? 0,
                currentCheck: vData?.currentCheck ?? false,
                RoundingAdjustments,
            })
        });
        const failedVouchers = [];
        for (let index = 0; index < OperationsList.length; index++) {
            const model = OperationsList[index];

            let voucher = auxVoucherList.find(({ Number }) => Number === model.Number);
            if (voucher.Completed) continue;
            showAlert({ type: "info", message: `Aplicando el deposito: ${model.Number}` });
            voucher.ApplyStatus = 'pending';
            voucher.ApplyMessage = '';
            setVoucherList(JSON.parse(JSON.stringify(auxVoucherList)));

            enableSpinner(true);
            const apiResponse = await apiClient.cashCutVoucher({ model }).catch(error => ({ status: 0, message: error?.message }));
            enableSpinner(false);
           
            if (apiResponse?.status !== SERVICE_RESPONSE.SUCCESS) {
                if (apiResponse?.data?.JdtNum) {
                    voucher.slResponseJDT = apiResponse.data;
                }
                voucher.ApplyStatus = 'error';
                voucher.ApplyMessage = apiResponse?.message || "Error al conectar con el servidor, intente más tarde";
                failedVouchers.push(voucher);
            } else {
                voucher.Completed = true;
                voucher.ApplyStatus = 'success';
                voucher.ApplyMessage = apiResponse?.message || 'Aplicado';
            }
            voucher.roundingPayments = apiResponse.data?.RoundingPayments ?? voucher.roundingPayments ?? [];
            setVoucherList(JSON.parse(JSON.stringify(auxVoucherList))); // Se guarda en cada vuelta para no reenviar los ya aplicados en un reintento
        }

        if (failedVouchers.length) {
            const appliedCount = auxVoucherList.filter(({ Completed }) => Completed).length;
            return showAlert({
                type: "error",
                message: `Depósitos aplicados: ${appliedCount} de ${auxVoucherList.length}. Con error: ${failedVouchers.map(({ Number }) => Number).join(', ')}. Revise el detalle en cada depósito y vuelva a intentar.`,
                timeOut: 12000
            });
        }

        if (incompleteOperations.length && type === 1) {
            enableSpinner(true);
            try {
                let responseApi;
                for (let attempt = 1; attempt <= 3; attempt++) {
                    let timeout;
                    try {
                        responseApi = await Promise.race([
                            apiClient.checkWorkSession(),
                            new Promise(resolve => { timeout = setTimeout(() => resolve({ status: 0, message: "La consulta de sesión excedió 30 segundos" }), 30000); })
                        ]).catch(error => ({ status: 0, message: error.message }));
                    } finally {
                        clearTimeout(timeout);
                    }
                    if (responseApi?.status) break;
                    console.error("[reconciliation] checkWorkSession", { idSession: cashCut.idSession, attempt, message: responseApi?.message });
                }
                if (responseApi?.status !== SERVICE_RESPONSE.SUCCESS || !responseApi?.data?.idSession)
                    throw new Error(responseApi?.message || "No se encontró una sesión activa para transferir las operaciones");

                showAlert({ type: "info", message: "Transfiriendo operaciones incompletas al corte actual" });
                const apiResponse = await apiClient.insertIncompleteOperations({ sourceIdWorkShift: cashCut.idSession, idWorkShift: responseApi.data.idSession, Operations: incompleteOperations });
                if (apiResponse?.status !== SERVICE_RESPONSE.SUCCESS || apiResponse?.data?.spConfirmed !== true)
                    throw new Error(apiResponse?.message || "No se confirmó la transferencia de operaciones incompletas");
            } catch (error) {
                console.error("[reconciliation] Operaciones incompletas", { idSession: cashCut.idSession, message: error.message });
                showAlert({ type: "error", message: `${error.message}. El corte no se completó`, timeOut: 12000 });
                return;
            } finally {
                enableSpinner(false);
            }
        }

        if (updateStatus) { await updateStatus(cashCut.idSession); }
        await closeModals();
        showAlert({ type: "success", message: "Operación completa" });
    };

    const cutTransfer = () => {
        setShowCutTransferModal(true);
    }

    const closeCutTransferModal = async (closeAll = false) => {
        if (closeAll) {
            await closeModals();
        } else {
            $("#cutTransferModal").modal("hide");
            $("#cutTransferUsersModal").modal("hide");
            $("#confirmCutTransferModal").modal("hide");
            setTimeout(() => {
                setShowCutTransferModal(false);
            }, 500);
        }
    }

    const openUnpaidOpsModal = () => {
        setShowUnpaidOpsModal(true);
    }

    const closeUnpaidOpsModal = async () => {
        $("#unpaidOpsModal").modal("hide");
        setTimeout(() => {
            setUnpaidOps([]);
            setShowUnpaidOpsModal(false);
        }, 500);
    }

    const unpaidOperationFields = operationFields.filter(
        ({ showInUnpaidOps }) => showInUnpaidOps
    );

    const getFormattedValue = (field, operation) => {
        let value = operation[field.key];

        if (operation?.isCesionEnUso === 'Y' && field.key === 'NumAtCard') {
            return `${operation.U_BPP_MDTD ?? ''}-${operation.U_BPP_PTSC ?? ''}-${operation.U_BPP_PTCC ?? ''}`;
        }

        if (field.needFormat) {
            return `${CURRENCY} ${FORMAT_NUMBER.new(value || 0)}`;
        }

        if (field.isDate) {
            return value || "";
        }

        return value || "";
    };

    //#endregion

    //#region Render
    const renderDepositCard = (cVoucher, index) => (
        <div key={index} className="border rounded p-2 mb-3">
            <div className="row">
                <div className="col-12 col-md-4 Depositos">
                    Deposito: {cVoucher.Number} <br />
                    Banco: {cVoucher.Bank}
                </div>
                <div className="col-12 col-md-4 Depositos">
                    Fecha: {moment(cVoucher.Date).isValid() ? moment(cVoucher.Date).format("DD/MM/YYYY") : "--"} <br />
                    Moneda: {cVoucher.Currency || " "}
                </div>
                <div className="col-12 col-md-4 d-flex align-items-center font-weight-bold">
                    <div className="w-100 text-right Depositos">
                        {CURRENCY} {FORMAT_NUMBER.new(cVoucher.Total)}
                        <i className="fa fa-trash-o" style={{ color: "#dc3545", margin: "1rem", cursor: 'pointer' }} onClick={() => removeDeposit(cVoucher, index)} />
                    </div>
                </div>
            </div>
        </div>
    );

    const renderDepositCardLink = (cVoucher, index) => (
        <div key={index} className="border rounded p-2 mb-3" style={{ background: index === selectedVoucher ? "rgb(255, 248, 210)" : "" }} onClick={() => setSelectedVoucher(index)}>
            <div className="row">
                <div className="col-12 col-md-3 Depositos">
                    Deposito: {cVoucher.Number} <br />
                    Banco: {cVoucher.Bank}
                </div>
                <div className="col-12 col-md-3 Depositos">
                    Fecha: {moment(cVoucher.Date).isValid() ? moment(cVoucher.Date).format("DD/MM/YYYY") : "--"} <br />
                    Moneda: {cVoucher.Currency || " "}
                </div>
                <div className="col-12 col-md-3 d-flex align-items-center font-weight-bold">
                    <div className="w-100 text-right Depositos">
                        Total: {CURRENCY} {FORMAT_NUMBER.new(cVoucher.Total)}
                    </div>
                </div>
                <div className="col-12 col-md-3 d-flex align-items-center font-weight-bold">
                    <div className="w-100 text-right Depositos">
                        Restante: {CURRENCY} {FORMAT_NUMBER.new(cVoucher.Remaining)}
                    </div>
                </div>
                {cVoucher.ApplyStatus && (
                    <div className="col-12 mt-2">
                        <div className={`alert py-1 px-2 mb-0 ${{ success: 'alert-success', error: 'alert-danger', pending: 'alert-info' }[cVoucher.ApplyStatus]}`} style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                            <strong>{{ success: 'Aplicado', error: 'Error', pending: 'Aplicando...' }[cVoucher.ApplyStatus]}</strong>
                            {cVoucher.ApplyMessage ? `: ${cVoucher.ApplyMessage}` : ''}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

    const getRoundingAdjustmentTotal = () => roundingAdjustments.reduce((acc, current) => acc += Number(current.AdjustmentAmount || 0), 0);

    const renderRoundingAdjustments = () => (
        <div className="col-12 border rounded p-3 mb-3">
            <div className="h5 font-weight-bold mb-3"> Ajuste por redondeo</div>
            {roundingAdjustments.map((adjustment, index) => (
                <div
                    key={index}
                    className={`border rounded p-2 ${index === (roundingAdjustments.length - 1) ? "" : "mb-3"}`}
                    style={{ background: "#f1f3f5" }}>
                    <div className="row d-flex justify-content-center">
                        <div className="col-12 col-md-6 col-lg-6">
                            <div>
                                <strong> Cliente: </strong>
                                {adjustment.cardCode}
                            </div>

                            <div>
                                <strong> Tipo: </strong>
                                {adjustment.docObjectType}
                            </div>

                            <div>
                                <strong> N° Doc: </strong>
                                {adjustment.docNum}
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6">
                            <div>
                                <strong> No.Ref: </strong>
                                {adjustment.NumAtCard}
                            </div>

                            <div>
                                <strong> Fecha: </strong>
                                {adjustment.docDate}
                            </div>

                            <div>
                                <strong> Ajuste: </strong>
                                {FORMAT_NUMBER.new(adjustment.AdjustmentAmount)}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );

    const renderOperation = (cOperation, index) => {
        const hasSapWarning = !!cOperation?.SapWarning;
        if (cOperation?.Remaining <= 0 && !hasSapWarning) return null; // Las que tienen observación en SAP se muestran aunque no tengan saldo, para que se vean

        const half = Math.ceil(operationFields?.length / 2);
        const leftFields = operationFields?.slice(0, half);
        const rightFields = operationFields?.slice(half);
        return (
            <div key={index} className={`border rounded p-2 mb-3 ${hasSapWarning ? 'border-warning' : ''}`}>
                {hasSapWarning && (
                    <div className="alert alert-warning py-1 px-2 mb-2 small">
                        <i className="fa fa-info-circle mr-2" />
                        {cOperation.SapWarning}
                    </div>
                )}
                <div className="row d-flex justify-content-center">
                    <div className="col-12 col-md-6 col-lg-6">
                        {leftFields.map((field, i) => (
                            <div key={i}>
                                <strong>
                                    {field.key === 'CashTotal' && cOperation?.isCesionEnUso === 'Y'
                                        ? 'T. GA/CU'
                                        : field.label
                                    }:
                                </strong>
                                {` ${getFormattedValue(field, cOperation)}`}
                            </div>
                        ))}
                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                        {rightFields.map((field, i) => (
                            <div key={i}>
                                <strong>
                                    {field.key === 'CashTotal' && cOperation?.isCesionEnUso === 'Y'
                                        ? 'T. GA/CU'
                                        : field.label
                                    }:
                                </strong>
                                {` ${getFormattedValue(field, cOperation)}`}
                            </div>
                        ))}
                    </div>
                    {cOperation?.Remaining > 0 && <div className="col-12 col-md-12 col-lg-6 mt-2">
                        <div className="input-group justify-content-center">
                            <input
                                className="form-control text-right"
                                style={{ maxWidth: 200 }}
                                value={cOperation.Amount || ""}
                                onChange={({ target: { value } }) =>
                                    changeAmountOperation(
                                        value === "." ? "0."
                                            : isNaN(`${value || ""}`.replace(/,/g, ""))
                                                ? cOperation.Amount
                                                : `${value || ""}`.trim(),
                                        index
                                    )
                                }
                                onBlur={() =>
                                    changeAmountOperation(
                                        FORMAT_NUMBER.new(`${cOperation.Amount || ""}`.replace(/,/g, "")),
                                        index
                                    )
                                }
                            />
                            <div className="input-group-prepend">
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={() => addOperation(index)}
                                >
                                    <i className="fa fa-plus-circle mr-2" />
                                </button>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        );
    };

    const renderOperationLinked = (cOperation, index) => {

        const half = Math.ceil(operationFields?.length / 2);
        const leftFields = operationFields?.slice(0, half);
        const rightFields = operationFields?.slice(half);

        return (
            <div key={`${cOperation.idSale}-${index}-${cOperation.CashApplied}`} className="border rounded p-2 mb-3">
                <div className="row d-flex justify-content-center">
                    <div className="col-12 col-md-6 col-lg-6">
                        {leftFields.map((field, i) => (
                            <div key={i}>
                                <strong>
                                    {field.key === 'CashTotal' && cOperation?.isCesionEnUso === 'Y'
                                        ? 'T. GA/CU'
                                        : field.label
                                    }:
                                </strong>
                                {` ${getFormattedValue(field, cOperation)}`}
                            </div>
                        ))}
                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                        {rightFields.map((field, i) => (
                            <div key={i}>
                                <strong>
                                    {field.key === 'CashTotal' && cOperation?.isCesionEnUso === 'Y'
                                        ? 'T. GA/CU'
                                        : field.label
                                    }:
                                </strong>
                                {` ${getFormattedValue(field, cOperation)}`}
                            </div>
                        ))}
                    </div>
                    <div className="col-6 text-center mt-2">
                        <button
                            type="button"
                            className="btn btn-danger"
                            style={{ whiteSpace: "nowrap" }}
                            onClick={() => removeOperation(cOperation, index)}
                        >
                            <i className="fa fa-trash mr-2" />
                            Quitar
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div id="AppsCashAmountModal" className="modal fade bd-example-modal-lg modal-open" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-lg modal-open">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="h4 font-weight-bold"> {selectByAmount ? "Monto a depositar" : "Operaciones a depositar"} </span>
                        </div>

                        <div className="modal-body py-3">
                            <div className="row px-3">
                                {selectByAmount ? (
                                    <div className="col-12 border rounded p-3 my-3">
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold"> Monto </span>
                                                    </div>
                                                    <input
                                                        className="form-control text-right"
                                                        value={cashCutAmount || ""}
                                                        onChange={({ target: { value } }) =>
                                                            setCashCutAmount(value === "." ? "0."
                                                                : isNaN(`${value || ""}`.replace(/,/g, "")) ? cashCutAmount
                                                                    : `${value || ""}`.trim())}
                                                        onBlur={() => setCashCutAmount(FORMAT_NUMBER.new(`${cashCutAmount || ""}`.replace(/,/g, "")))} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>)
                                    : (
                                        <div className="col-12 border rounded p-3 my-3" style={{ maxHeight: 300, overflow: "auto" }}>
                                            {operations?.length ? operations.map((operation, index) => (
                                                <div
                                                    key={index}
                                                    onClick={() => type === 0 && setOperations(prev => prev.map((curr, i) => i === index ? { ...curr, Selected: !operation.Selected } : curr))}
                                                    className={`border rounded p-2 ${index === (operations.length - 1) ? "" : "mb-3"}`}
                                                    style={{ cursor: type === 0 ? "pointer" : 'normal', background: operation.Selected ? "#fff8e2" : "" }}>
                                                    <div className="row d-flex justify-content-center">
                                                        <div className="col-12 col-md-6 col-lg-6">
                                                            <div>
                                                                <strong> Cliente: </strong>
                                                                {operation.cardCode}
                                                            </div>

                                                            <div>
                                                                <strong> Tipo: </strong>
                                                                {operation.docObjectType}
                                                            </div>

                                                            <div>
                                                                <strong> N° Doc: </strong>
                                                                {operation.docNum}
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-6 col-lg-6">
                                                            <div>
                                                                <strong> No.Ref: </strong>
                                                                {operation.NumAtCard}
                                                            </div>

                                                            <div>
                                                                <strong> Fecha: </strong>
                                                                {operation.docDate}
                                                            </div>

                                                            <div>
                                                                <strong> {operation?.isCesionEnUso === 'Y' ? 'T. GA/CU' : "Total"}: </strong>
                                                                {FORMAT_NUMBER.new(operation.CashTotal)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )) : "Sin operaciones"}
                                        </div>)
                                }

                                {(!selectByAmount && roundingAdjustments?.length > 0) && renderRoundingAdjustments()}

                                {(!selectByAmount && roundingAdjustments?.length > 0) && (
                                    <div className="col-12 d-flex flex-column align-items-end">
                                        <span> Total a depositar: {CURRENCY} {FORMAT_NUMBER.new(operations.reduce((acc, current) => acc += (current.Selected ? Number(current.CashTotal) : 0), 0))} </span>
                                        <span> Ajuste por redondeo CU: {CURRENCY} {FORMAT_NUMBER.new(getRoundingAdjustmentTotal())} </span>
                                    </div>
                                )}

                                <div className="col-12 d-flex">
                                    <span className="ml-auto h5 font-weight-bold Depositos">
                                        Total: {CURRENCY} {selectByAmount ? cashCutAmount :
                                            FORMAT_NUMBER.new(
                                                operations.reduce((acc, current) => acc += (current.Selected ? Number(current.CashTotal) : 0), 0)
                                                + getRoundingAdjustmentTotal()
                                            )
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer d-flex justify-content-end align-items-center">
                            {(!selectByAmount && type === 0) && (
                                <div className="input-group" style={{ width: '220px' }}>
                                    <div className="input-group-prepend">
                                        <div className="input-group-text font-weight-bold">
                                            <input
                                                type="checkbox"
                                                style={{ transform: 'scale(1.5)' }}
                                                id="inSelectAll"
                                                checked={!operations.find((operation) => !operation.Selected)}
                                                onChange={({ target: { checked } }) => setOperations(prev => prev.map(curr => ({ ...curr, Selected: checked })))} />
                                        </div>
                                    </div>
                                    <label className="form-control" htmlFor="inSelectAll"> Seleccionar Todo </label>
                                </div>
                            )}

                            <div>
                                <button type="button" onClick={verifyCashCutAmount} className="btn btn-warning mr-2" > Continuar </button>
                                <button type="button" onClick={() => $("#cancelModal").modal("show")} className="btn btn-secondary"> Cancelar </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="AppsCashCutModal" className="modal fade bd-example-modal-lg modal-open" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-lg modal-open">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="h4 font-weight-bold"> Registro de depósitos </span>
                        </div>
                        <div className="modal-body py-3">
                            <div className="row px-3">
                                <div className="col-12 mb-3 Depositos">
                                    <span className="ml-auto h5 font-weight-bold Depositos"> Efectivo Total: {CURRENCY} {FORMAT_NUMBER.new(cashTotal)}</span>
                                </div>

                                <div className="col-12 border rounded p-3">
                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> N° Mov </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    value={voucher.number || ""}
                                                    onChange={({ target: { value } }) => setVoucher({ ...voucher, number: `${value || ""}`.slice(0, 20) })} />
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Banco </span>
                                                </div>
                                                {/* <input
                                                    className="form-control"
                                                    value={voucher.bank || ""}
                                                    onChange={({ target: { value } }) => setVoucher({ ...voucher, bank: `${value || ""}`.slice(0, 20) })} /> */}
                                                <select
                                                    name="select"
                                                    className="form-control"
                                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                    value={voucher.bank || ''}
                                                    onChange={({ target: { value } }) =>
                                                        setVoucher({ ...voucher, bank: `${value || ""}`.slice(0, 20) })
                                                    }
                                                >
                                                    <option value="">Seleccionar</option>
                                                    {!!bankOptions && bankOptions?.map(bank => {
                                                        return (
                                                            <option value={bank.BankCode}>{bank.BankName || ''}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                            <div className="input-group mb-3 mb-md-0">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Fecha </span>
                                                </div>
                                                <input
                                                    className="form-control text-right"
                                                    type="date"
                                                    value={voucher.date || ""}
                                                    onChange={({ target: { value } }) => setVoucher({ ...voucher, date: value })} />
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Moneda </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    value={voucher.currency || ""}
                                                    onChange={({ target: { value } }) => setVoucher({ ...voucher, currency: `${value || ""}`.toLocaleUpperCase().slice(0, 10) })} />
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Monto </span>
                                                </div>
                                                <input
                                                    className="form-control text-right"
                                                    value={voucher.total || ""}
                                                    onChange={({ target: { value } }) =>
                                                        setVoucher({
                                                            ...voucher, total: value === "." ? "0."
                                                                : isNaN(`${value || ""}`.replace(/,/g, "")) ? voucher.total
                                                                    : `${value || ""}`.trim()
                                                        })}
                                                    onBlur={() => setVoucher({ ...voucher, total: FORMAT_NUMBER.new(`${voucher.total || ""}`.replace(/,/g, "")) })} />
                                            </div>

                                            <div className="d-flex justify-content-end">
                                                <button
                                                    className="btn btn-success btnNuevo"
                                                    style={{ minWidth: 120 }}
                                                    onClick={validateVoucher}>
                                                    <i className="fa fa-plus mr-2" />
                                                    Agregar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 border rounded p-3 my-3 Depositos" style={{ maxHeight: 300, overflow: "auto" }}>
                                    {voucherList?.length ? voucherList.map(renderDepositCard)
                                        : "Sin depositos registrados"}
                                </div>

                                {roundingAdjustments?.length > 0 && renderRoundingAdjustments()}

                                <div className="col-12 col-md-6 col-lg-6 d-flex flex-column align-items-end">
                                    <span className="h5 font-weight-bold Depositos"> Restante: {CURRENCY} {FORMAT_NUMBER.new(((cashTotal - voucherList.reduce((acc, current) => acc += Number(current.Total), 0)) * 100) / 100)}</span>
                                    {roundingAdjustments?.length > 0 && (
                                        <span> Ajuste por redondeo CU: {CURRENCY} {FORMAT_NUMBER.new(getRoundingAdjustmentTotal())} </span>
                                    )}
                                </div>
                                <div className="col-12 col-md-6 col-lg-6 d-flex">
                                    <span className="ml-auto h5 font-weight-bold Depositos"> Total: {CURRENCY} {FORMAT_NUMBER.new(voucherList.reduce((acc, current) => acc += Number(current.Total), 0))}</span>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-end align-items-center">

                            {/* {type == 0 && */}
                            <div className="input-group" style={{ width: '220px' }}>
                                <div className="input-group-prepend">
                                    <div className="input-group-text font-weight-bold">
                                        <input
                                            type="checkbox"
                                            style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                            id={`checkR`}
                                            checked={currentCheck}
                                            onChange={({ target: { checked } }) =>
                                                setCurrentCheck(checked)
                                            }
                                        />
                                    </div>
                                </div>

                                <input
                                    className="form-control"
                                    id={`inputR`}
                                    value={'Redondeo'}
                                    readOnly
                                />
                            </div>
                            {/* } */}

                            <div>
                                <button
                                    type="button"
                                    onClick={verifyVoucherList}
                                    className="btn btn-warning mr-2"
                                >
                                    Continuar
                                </button>

                                <button
                                    type="button"
                                    onClick={() => $("#cancelModal").modal("show")}
                                    className="btn btn-secondary"
                                >
                                    Cancelar
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div id="LinkOperationsModal" className="modal fade bd-example-modal-xl modal-open" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-xl modal-open">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="h4 font-weight-bold"> Relación de Depositos - Operaciones </span>
                        </div>
                        <div className="modal-body py-2">
                            <div className="row">
                                <div className="col-12">
                                    <div className="border rounded p-3 mb-3">
                                        <div className="w-100 d-flex align-items-center mb-3">
                                            <label className="h5 font-weight-bold mb-3"> Depositos </label>
                                            <button type="button" onClick={fillOperationsByMatch} className="btn btn-primary ml-auto"> Seleccion Automatica </button>
                                        </div>

                                        <div className="w-100 px-2 Depositos" style={{ height: 180, overflow: "auto" }}>
                                            {voucherList.map(renderDepositCardLink)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="border rounded p-3">
                                        <label className="h5 font-weight-bold mb-3"> Operaciones Disponibles </label>

                                        <div className="w-100 px-2 Depositos" style={{ height: 300, overflow: "auto" }}>
                                            {operations.map(renderOperation)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="border rounded p-3 Depositos">
                                        <label className="h5 font-weight-bold mb-3"> Operaciones Seleccionadas </label>

                                        <div className="w-100 px-2 Depositos" style={{ height: 300, overflow: "auto" }}>
                                            {!(Array.isArray(voucherList[selectedVoucher]?.operations) && voucherList[selectedVoucher]?.operations?.length) ? "Sin operaciones"
                                                : voucherList[selectedVoucher].operations.map(renderOperationLinked)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                onClick={async () => {
                                    await $("#LinkOperationsModal").modal("hide");
                                    await $("#AppsCashCutModal").modal("show");
                                }}
                                className="btn btn-secondary"
                            >
                                Regresar
                            </button>
                            <button type="button" onClick={() => $("#continueModal").modal("show")} className={`btn btn-${enableContinue ? "warning" : "dark"}`} disabled={!enableContinue}> Continuar </button>
                            <button type="button" onClick={() => $("#cancelModal").modal("show")} className="btn btn-secondary"> Cancelar </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="continueWithoutVouchers" className="modal fade" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="h4 font-weight-bold"> Advertencia </span>
                        </div>
                        <div className="modal-body py-2">
                            <strong> No se han registrado depósitos bancarios. </strong><br />
                            Esto cargará el efectivo restante y las operaciones sin relacionar en su corte actual. <br /> <br />
                            ¿Esta seguro que desea continuar con el corte del operador sin realizar depósitos bancarios?
                        </div>
                        <div className="modal-footer">
                            {type === 0 && <button type="button" onClick={() => cutTransfer()} className="btn btn-outline-dark"> Traspaso del corte </button>}
                            <button type="button" onClick={reconciliation} className="btn btn-warning"> Continuar sin Depositos </button>
                            <button type="button" onClick={() => $("#continueWithoutVouchers").modal("hide")} className="btn btn-secondary"> Volver </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="continueModal" className="modal fade" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="h4 font-weight-bold"> Confirmación </span>
                        </div>
                        <div className="modal-body py-2">
                            El efectivo restante y las operaciones sin relacionar se cargarán en su corte actual. <br /> <br />
                            ¿Esta seguro que desea continuar?
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={reconciliation} className="btn btn-warning"> Continuar </button>
                            <button type="button" onClick={() => $("#continueModal").modal("hide")} className="btn btn-secondary"> Volver </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="cancelModal" className="modal fade" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="h4 font-weight-bold"> Confirmación </span>
                        </div>
                        <div className="modal-body py-2">
                            ¿Esta seguro que desea salir del corte de efectivo?
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={closeModals} className="btn btn-warning"> Cerrar </button>
                            <button type="button" onClick={() => $("#cancelModal").modal("hide")} className="btn btn-secondary"> Volver </button>
                        </div>
                    </div>
                </div>
            </div>

            {showCutTransferModal && type === 0 &&
                <CutTransferModal
                    showAlert={showAlert}
                    enableSpinner={enableSpinner}
                    cleanData={closeCutTransferModal}
                />
            }

            {showUnpaidOpsModal && type === 0 &&
                <div id="unpaidOpsModal" className="modal fade bd-example-modal-lg bgtransparent" role="dialog" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Operaciones sin pagos recibidos
                                </h5>
                            </div>
                            <div className="modal-body">
                                <>
                                    <strong>Para poder continuar con el registro de depósitos es necesario que las siguientes operaciones cuenten con un pago recibido.</strong>
                                    <div className="table-responsive mt-3" style={{ maxHeight: 400, overflowY: "auto" }}>
                                        <table className="table table-bordered table-hover text-center" style={{ width: "100%" }}>
                                            <thead className="table-header-yellow" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                                <tr>
                                                    {unpaidOperationFields?.map((field) => (
                                                        <th key={field.key}>
                                                            {field.label}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {(unpaidOps ?? []).length === 0 ? (
                                                    <tr>
                                                        <td colSpan={unpaidOperationFields?.length}>
                                                            Sin información
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    unpaidOps.map((operation, index) => (
                                                        <tr key={index}>
                                                            {unpaidOperationFields?.map((field) => (
                                                                <td key={field.key} style={{ whiteSpace: "nowrap" }}>
                                                                    {getFormattedValue(field, operation)}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={closeUnpaidOpsModal} className="btn btn-secondary"> Cerrar </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
    //#endregion
}